import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ActivePasskey {
  passkeyProviderName: string;
  dateCreated: string;
  lastUsed: string;
  id: string;
  status: string;
}

export interface PasskeyListPayload {
  apiName: string;
  data: {
    accountId: string;
    customerId: string;
    flow: string;
  };
}

export interface PasskeyListState {
  loading: boolean;
  activePasskeys: ActivePasskey[];
  userId: string | null;
  error: any | null;
}

const initialState: PasskeyListState = {
  loading: false,
  activePasskeys: [],
  userId: null,
  error: null,
};

const passkeyListSlice = createSlice({
  name: 'passkeyList',
  initialState,
  reducers: {
    passkeyListRequest(state, _action: PayloadAction<PasskeyListPayload>) {
      state.loading = true;
      state.error = null;
    },
    passkeyListSuccess(
      state,
      action: PayloadAction<{
        activePasskeys?: ActivePasskey[];
        userId?: string;
      }>
    ) {
      state.loading = false;
      state.activePasskeys = Array.isArray(action.payload?.activePasskeys)
        ? action.payload.activePasskeys
        : [];
      state.userId = action.payload?.userId ?? null;
      state.error = null;
    },
    passkeyListFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.activePasskeys = [];
      state.userId = null;
      state.error = action.payload;
    },
    resetPasskeyList() {
      return initialState;
    },
  },
});

export const {
  passkeyListRequest,
  passkeyListSuccess,
  passkeyListFailed,
  resetPasskeyList,
} = passkeyListSlice.actions;

export default passkeyListSlice.reducer;
